// removed by extract-text-webpack-plugin
module.exports = {"Blueberry":"#3E3AC2","Bluecheese":"#615CFF","body":"Gfc7417 G699d38 Gcc633e Ge0b40c","bottom":"G13314e","link":"Ga9f8db"};